import { memo } from 'react';

import { FormGuideMatchExtended } from './FormGuideMatchExtended';

import type { FormGuideMatch } from '@shared-types/form-guide.types';
import type { Team } from '@shared-types/match.types';

const ExtendedView = ({ matches, team }: { matches: FormGuideMatch[]; team: Team }) => {
  if (!matches?.length) return null;

  return (
    <ul>
      {matches.map(({ match, outcome }) => (
        <li key={`item_${match.id}`}>
          <FormGuideMatchExtended team={team} match={match} outcome={outcome} />
        </li>
      ))}
    </ul>
  );
};

export default memo(ExtendedView);
